import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutBottom"><Path d="M20.5 3.5V17.5L3.5 17.5V3.5L20.5 3.5Z" stroke="currentColor"/><Path d="M21 20.5H3" stroke="currentColor"/></CentralIconBase>;
});

export default IconLayoutBottom;
